module.exports = __webpack_public_path__ + "img/9788980072019.676de3b0.jpg";